/*
 * Copyright (c) 2023 SGS Europe. All rights reserved.
 *
 * This program is the CONFIDENTIAL and PROPRIETARY property of SGS Europe.
 * Any unauthorised use, reproduction, or transfer of this program is strictly
 * prohibited.
 *
 * File Name:	GreenlightTextCompare_Equivalents.js
 *
 * Description:	The class containing the functionality required by the Greenlight for text compare equivalents.
 * 
 */

// The text compare object.
var g_oTextCompare_Equivalents = {};

(function () {
	"use strict";

	/**
	 * Load the text content for the page.
	 */
	function TextCompareEquivalents() {

		// Outline the text equivalents to be populated.
		this.g_oTextEquivalents = null;
	};

	/**
	 * Loads the text equivalents.
	 */
	TextCompareEquivalents.prototype.loadTextEquivalents = function () {

		// Build up the JSON to be posted.
		var oJSON = {
			SessionId: g_szSessionId,
			ConsumerId: g_oViewer.g_oArtworkViewer.g_oDoc.consumerId
		};

		// Call to load the text data.
		$.ajax({
			type: "POST",
			url: "TextTools/GetTextEquivalents",
			data: JSON.stringify(oJSON),
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			success: function (response) {
				g_oTextCompare_Equivalents.loadTextEquivalents_CH(response);
			},
			failure: function (response) {
				g_oTextCompare_Equivalents.g_oTextEquivalents = [];
				g_oGreenlightMessages.displayErrorBubble(g_oTextCompare_Equivalents.c_szTextCompareFailedToLoadEquivalents);
			}
		});
	};

	/**
	 * Callback for loading the text equivalents.
	 * @param {object} response - The response of the load.
	 */
	TextCompareEquivalents.prototype.loadTextEquivalents_CH = function (response) {

		// If unsuccessful, set that we have no text equivalents and display an error bubble.
		if (!response.Success) {
			g_oTextCompare_Equivalents.g_oTextEquivalents = [];
			g_oGreenlightMessages.displayErrorBubble(g_oTextCompare_Equivalents.c_szTextCompareFailedToLoadEquivalents);
			return;
		}

		// Extract the equivalents.
		g_oTextCompare_Equivalents.g_oTextEquivalents = JSON.parse(response.Contents);

		// If we have text equivalents.
		if (g_oTextCompare_Equivalents.g_oTextEquivalents.length > 0) {

			// Render the text equivalents.
			g_oTextCompare_Equivalents.renderTextEquivalents();
		}
	};

	/**
	 * Renders the text equivalents.
	 */
	TextCompareEquivalents.prototype.renderTextEquivalents = function () {

		// Build up the HTML for the text equivalents.
		var szHTML = '';

		// Add the header.
		szHTML += g_oTextCompare_Equivalents.c_szTextCompareTextEquivalents + ":";

		// Loop through and add each of the text equivalents.
		for (var i = 0; i < g_oTextCompare_Equivalents.g_oTextEquivalents.length; i++) {
			szHTML += ' [' + g_oTextCompare_Equivalents.g_oTextEquivalents[i].TextContent + ' → ' + g_oTextCompare_Equivalents.g_oTextEquivalents[i].EquivalentContent + ']';
		}

		// Apply the HTML.
		$("#divTextCompareEquivalentsContent").html(szHTML);
	};

	/**
	 * Toggles the text equivalents.
	 */
	TextCompareEquivalents.prototype.toggleTextEquivalents = function () {

		// Slide toggle the equivalents.
		$("#divTextCompareEquivalents").slideToggle(null, "", function () {

			// Update the height of the text compare sections.
			g_oTextCompare.updateTextCompareSectionsHeight();
		});
	};

	/**
	 * Removes the text equivalents from the modifications.
	 * @param {object} oModifications - The modification list.
	 */
	TextCompareEquivalents.prototype.removeTextEquivalentsFromModifications = function (oModifications) {

		// Check we have equivalents to evaluate.
		// White space can count as an equivalent if the setting is off.
		if ((g_oTextCompare_Equivalents.g_oTextEquivalents == null || g_oTextCompare_Equivalents.g_oTextEquivalents.length == 0) && g_oTextCompare.g_iWhitespaceDetection == g_oTextCompare.eWhitespaceDetectionLevels.On) {
			return;
		}

		// Loop through each of the modifications.
		for (var i = 0; i < oModifications.length; i++) {

			// If this is a deletion followed by an addition, this is a substitution that may only be a character equivalent difference.
			if (oModifications[i].g_eDifferenceType == g_oTextCompare.eDifferenceTypes.Deletion && (i + 1) < oModifications.length && oModifications[i + 1].g_eDifferenceType == g_oTextCompare.eDifferenceTypes.Addition) {

				// Keep track of if this is an equivalent only substitution.
				var bEquivalentOnlySubstitution = false;

				// Get the substitution text to be checked.
				var szApprovalSubstitutionText = oModifications[i].g_szModificationText;
				var szCompareSubstitutionText = oModifications[i + 1].g_szModificationText;

				// If this text is the same following the swapping out of equivalents.
				if (g_oTextCompare_Equivalents.replaceTextEquivalents(szApprovalSubstitutionText) == g_oTextCompare_Equivalents.replaceTextEquivalents(szCompareSubstitutionText)) {

					// Set that this is an equivalent only substitution.
					bEquivalentOnlySubstitution = true;
				}

				// We may need to add something in future to include the no difference text from either side, 
				// then re-compare incase the equivalent is split across characters.

				// If this was an equivalent only substitution.
				if (bEquivalentOnlySubstitution) {

					// Update the statuses and mappings of these modifications.
					oModifications[i].g_eDifferenceType = g_oTextCompare.eDifferenceTypes.NoDifference;
					oModifications[i].g_eDifferenceMapping = g_oTextCompare.g_eDifferenceMapping.CompareOnly;
					oModifications[i + 1].g_eDifferenceType = g_oTextCompare.eDifferenceTypes.NoDifference;
					oModifications[i + 1].g_eDifferenceMapping = g_oTextCompare.g_eDifferenceMapping.ApprovalOnly;
				}
			}
		}
	};

	/**
	 * Replaces text equivalents.
	 * @param {string} szText - The text.
	 */
	TextCompareEquivalents.prototype.replaceTextEquivalents = function (szText) {

		// Loop through each of the text equivalents.
		if (g_oTextCompare_Equivalents.g_oTextEquivalents != null) {
			for (var i = 0; i < g_oTextCompare_Equivalents.g_oTextEquivalents.length; i++) {

				// Replace this text equivalent.
				szText = szText.split(g_oTextCompare_Equivalents.g_oTextEquivalents[i].TextContent).join(g_oTextCompare_Equivalents.g_oTextEquivalents[i].EquivalentContent);
			}
		}

		// If we are ignoring whitespace differences, count any white space as equivalents.
		if (g_oTextCompare.g_iWhitespaceDetection == g_oTextCompare.eWhitespaceDetectionLevels.Off) {
			szText = szText.replace(/\s/g, '');
		}

		// Return the updated text.
		return szText;
	};

	// Add the Text Compare Equivalents object to the window.
	window.TextCompareEquivalents = TextCompareEquivalents;
}());